import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { CodeConfigFile } from "../../../../interfaces/code-config-file";

type FileListItem = Partial<CodeConfigFile> & { filename: string; size?: number };

@Component({
  selector: "file-list",
  templateUrl: "./file-list.component.html",
  styleUrls: ["./file-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileListComponent {
  @Input() files: FileListItem[] = [];
  @Input() removable = false;
  @Input() clickableNames = false;
  @Output() remove = new EventEmitter<number>();
  @Output() fileNameClick = new EventEmitter<number>();

  onRemove(index: number): void {
    this.remove.emit(index);
  }

  onFileNameClick(index: number): void {
    if (!this.clickableNames) {
      return;
    }

    this.fileNameClick.emit(index);
  }
}
